import { Injectable } from '@angular/core';
import { isBrowserReloadShortcut } from './browser-refresh-block.util';

/**
 * Blocks browser reload shortcuts (F5, Ctrl/Cmd+R, Ctrl/Cmd+Shift+R, Ctrl/Cmd+F5).
 * Use in-app refresh buttons to reload list data. Does not stopPropagation so
 * transaction shortcuts (e.g. F5 on Sales Billing) still work.
 */
@Injectable({ providedIn: 'root' })
export class BrowserRefreshBlockService {
  private listenerAttached = false;
  private readonly windowKeydownCapture = (event: KeyboardEvent): void =>
    this.onWindowKeydownCapture(event);

  initEarlyListener(): void {
    if (this.listenerAttached || typeof window === 'undefined') {
      return;
    }
    window.addEventListener('keydown', this.windowKeydownCapture, true);
    this.listenerAttached = true;
  }

  private onWindowKeydownCapture(event: KeyboardEvent): void {
    if (!isBrowserReloadShortcut(event)) {
      return;
    }
    event.preventDefault();
  }
}
